export const CludoConfig = {
  endpoint: "https://api-us1.cludo.com/api/v3",
  customerId: 10001489,
  dev: {
    engineId: 10002571,
  },
  stage: {
    engineId: 10002604,
  },
  prod: {
    engineId: 10002607,
  },
  cloudDev: {
    engineId: 10002563,
  },
};
